class MixpanelController {
    init() {}
    identify = () => {}
    alias = () => {}
    track = () => {}
    register = () => {};
    register_once = () => {};
    reset = () => {};
    people = {};
    opt_out_tracking = () => {}
    kill = () => {}
    onload = () => {}
}

export const Mixpanel = new MixpanelController();
